import { render, staticRenderFns } from "./NewCreatedFileScroll.vue?vue&type=template&id=4f397b20&scoped=true&"
import script from "./NewCreatedFileScroll.vue?vue&type=script&lang=js&"
export * from "./NewCreatedFileScroll.vue?vue&type=script&lang=js&"
import style0 from "./NewCreatedFileScroll.vue?vue&type=style&index=0&id=4f397b20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f397b20",
  null
  
)

export default component.exports